import request from '@/utils/request'

// 活动记录
export function getActivityRecordList(data) {
  return request({
    url: '/admin/activity/webActRecord/list',
    method: 'post',
    data
  })
}
